import { FormContext } from "@stormwater-software/lib-form";
import { LayoutTypes } from "@stormwater-software/lib-inspection-templates";
import {
  defaultTemplateRenderer,
  QuestionContext,
  QuestionGroupContext,
  RenderContextValue,
  UserDataContext,
} from "@stormwater-software/ui-inspection-templates";
import classnames from "classnames";
import React, { useContext, useEffect } from "react";

export const TemplateQuestion: RenderContextValue["Question"] = props => {
  const formContext = useContext(FormContext);
  const question = useContext(QuestionContext);
  const group = useContext(QuestionGroupContext);
  const userDataContext = useContext(UserDataContext);

  useEffect(() => {
    if (question.id) {
      /** @important ensure context is aware of question data */
      formContext && formContext.set(
        `question-${question.id}`,
        userDataContext.answers[question.id] || "",
      );
    }

    return () => {
      formContext && formContext.set(`question-${question.id}`, undefined);
    };
  }, []);

  return (
    <defaultTemplateRenderer.Question
      {...props}
      className={classnames({
        "form-group": group.layout_type === LayoutTypes.FORM,
      })}
    />
  );
};
